import actionCreatorFactory from 'typescript-fsa'
import { Api } from 'typescript-fetch-api'

const actionCreator = actionCreatorFactory('KnowledgeLibrary')

export const loadKnowledgeLibrary = actionCreator.async<undefined, Api.KnowledgeLibrary, Error>('LOAD_KNOWLEDGE_LIBRARY')
